





















import PageBody from "@/components/PageBody.vue";
import PageHeader from "@/components/PageHeader.vue";
import { Component, Mixins } from "vue-property-decorator";
// eslint-disable-next-line no-unused-vars
import { Message } from "@/types/message";
import { MessageHttp } from "@/mixins/http/message";

@Component({
	components: {
		"page-header": PageHeader,
		"page-body": PageBody,
	},
})
export default class Inbox extends Mixins(MessageHttp) {
	messages: Message[] = [];

	mounted() {
		this.getMessagesForRecipient(this.$store.getters["account/currentUser"].userId).then(
			(response) => {
				this.messages = response.data;
			}
		);
	}
}
